export const ELEMENT_INDIVIDUAL_DUPLICATION = 'ELEMENT_INDIVIDUAL_DUPLICATION';
export const ELEMENT_DUPLICATION_PROCESSING = 'ELEMENT_DUPLICATION_PROCESSING';
export const ELEMENT_DUPLICATION_COMPLETE = 'ELEMENT_DUPLICATION_COMPLETE';
